import { render, staticRenderFns } from "./orderGoodsInfo.vue?vue&type=template&id=3cdb2e79&"
import script from "./orderGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./orderGoodsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports